export default {
  text: 'Event Email 3',
  thumbnail:
    'https://vastreach.com/static_assets/email/thumnails/Event_email_3.jpg',
  snippets: {
    Button: {
      icon: 'RadioButton',
      text: 'Button',
      editor: 'button',
      html: '<!-- Dynamic WYSIWYG Content --><div style="max-width: 600px;margin: 0 auto 0;padding: 10px 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;"><p style="text-align: center;margin:0;"><a data-button-text="Start now" data-button-url="https://www.vastreach.com" data-button-color="#000000" data-button-background-color="#4dcaf3" href="#" target="_blank"><button style="color: #000000; background-color:#4dcaf3; border: 0; padding: 15px 25px; margin: 0; border-radius: 0.35rem; cursor: pointer;"><strong>Start Now</strong></button></a></p></div><!-- End of Dynamic WYSIWYG Content -->',
    },
    Social: {
      icon: 'Share',
      text: 'Social',
      editor: 'social-media',
      html: '<!-- Dynamic WYSIWYG Content --><table style="margin: 0 auto;background: transparent;" border="0" cellpadding="0" cellspacing="0" align="center"><tr><td width="600" align="center"><table style="margin: 20px 0 20px 0;"><tr><td align="center"> <a data-social-media="facebook" href="https://www.facebook.com/" target="_blank"><img src="https://vastreach.com/static_assets/facebook.png" border="0" style="background-color: #4dcaf3;padding: 4px; border-radius:28px;" /></a> </td><td align="center"> <a data-social-media="instagram" href="https://www.instagram.com/" target="_blank"><img src="https://vastreach.com/static_assets/instagram.png" border="0" style="background-color: #4dcaf3;padding: 4px; border-radius:28px;" /></a> </td><td align="center"> <a data-social-media="twitter" href="https://twitter.com/" target="_blank"><img src="https://vastreach.com/static_assets/twitter.png" border="0" style="background-color: #4dcaf3;padding: 4px; border-radius:28px;" /></a> </td></tr></table></td></tr></table><!-- End of Dynamic WYSIWYG Content -->',
    },
    Paragraph: {
      icon: 'Notes',
      text: 'Paragraph',
      editor: 'wysiwyg',
      html: `<!-- Dynamic WYSIWYG Content --><div style="padding: 10px;margin: 0 auto;background: transparent;width:100%;max-width: 600px;"><p style="font-family: Tahoma, Geneva, sans-serif; color: #777777; text-align: center;"><strong><span style="color: rgba(0, 0, 0, 1);"> Email marketing is the act of sending a commercial message, typically to a group of people, using email. In its broadest sense, every email sent to a potential or current customer could be considered email marketing. It involves using email to send advertisements, request business, or solicit sales or donations. </span></strong></p></div><!-- End of Dynamic WYSIWYG Content -->`,
    },
  },
  value: `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
  <html xmlns="http://www.w3.org/1999/xhtml" style="width: 100%;height: 100%;margin: 0;padding: 0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">
  
  <head>
      <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="viewport" content="width=device-width"/>
      <meta class="vastreach-theme" data-vast-theme="event3"/>
  </head>	
  
  <body align="center" style="margin: 0;padding:0;background-color: #ffffff;">
    <div class="background" style="background: #ffffff;">
      <div class="foreground" style="max-width: 600px;background: #ffffff;">
        <table style="max-width: 600px;margin: 0 auto 0;padding: 0;text-align: center;border-radius: .35rem;border-spacing: 0;">
      
        <tr>
          <td class="vastreach-sections" data-vast-editor="paragraph" style="display:block; margin: 0;">
          <!-- Dynamic WYSIWYG Content -->
          <div style="padding: 10px;margin: 0 auto;background-color: #000000;width:100%;max-width: 600px;">
            <p><span style="color: #4dcaf3"> </span></p>
            <h1 style="font-weight: 600; font-family: Tahoma, Geneva, sans-serif; margin-left: 20px; text-align: center;"><span style="color: #4dcaf3; font-size: x-large;">SPRING/SUMMER EXPO    </span><span style="color: #4dcaf3;">                                                                        </span></h1>
            <p style="text-align: center;"><span style="color: #ffffff;"> </span></p>
          </div>
          <!-- End of Dynamic WYSIWYG Content -->
          </td>	
        </tr>	

        <tr>
          <td class="vastreach-sections" data-vast-editor="img-picker">
            <!-- Dynamic WYSIWYG Content -->
            <div style="width: 100%;max-width: 600px;margin: 0 auto;padding: 0;text-align: center;background: transparent;">
              <img src="https://vastreach.com/static_assets/email/event_email_3/product_x_banner.jpg" alt="event email banner" style="max-width: 100%;margin: 0 auto;display: block;">
            </div>
            <!-- End of Dynamic WYSIWYG Content -->   
          </td>	
        </tr>	

        <tr>
          <td class="vastreach-sections" data-vast-editor="paragraph" style="display:block; margin: 0;">
            <!-- Dynamic WYSIWYG Content -->
            <div style="margin: 0 20px;padding: 10px 10px 10px 10px;background: transparent;">
              <h5 style="font-family: Tahoma, Geneva, sans-serif; color: #777777; text-align: center;"><span style="font-size: medium;"> </span><span style="color: #000000; font-size: medium;">Email marketing is the act of sending a commercial message, typically to a group of people, using email. In its broadest sense, every email sent to a potential or current customer could be considered email marketing. It involves using email to send advertisements, request business, or solicit sales or donations. </span></h5>
            </div>
            <!-- End of Dynamic WYSIWYG Content -->  
          </td>	
        </tr>	

        <tr>
          <td class="vastreach-sections" data-vast-editor="button">
            <!-- Dynamic WYSIWYG Content -->
            <div style="max-width: 600px;margin: 0 auto 0;padding: 10px 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">
              <p style="text-align: center;margin:0;">
                <a data-button-text="Start now" data-button-url="https://www.vastreach.com" data-button-color="#000000" data-button-background-color="#4dcaf3;" href="#" target="_blank">
                  <button style="color: #000000; background-color:#4dcaf3; border: 0; padding: 15px 25px; margin: 0; border-radius: 0.35rem; cursor: pointer;"><strong>Start Now</strong></button>
                </a>
              </p>
            </div>
            <!-- End of Dynamic WYSIWYG Content -->
          </td>	
        </tr>

        <tr>
          <td class="vastreach-sections" data-vast-editor="paragraph" style="display:block; margin: 0;">    
            <!-- Dynamic WYSIWYG Content -->
            <div style="padding: 10px;margin: 0 auto;background-color: #000000;width:100%;max-width: 600px;">
              <p><span style="color: #4dcaf3"> </span></p>
              <h1 style="font-weight: 600; font-family: Tahoma, Geneva, sans-serif; margin-left: 20px; text-align: center;"><span style="color: #4dcaf3; font-size: x-large;">THIS WEEK ONLY! DONT MISS OUT!</span><span style="color: #4dcaf3; font-size: x-large;">     </span><span style="color: #4dcaf3;">                                                                        </span></h1>
              <p style="text-align: center;"><span style="color: #ffffff;"> </span></p>
            </div>
            <!-- End of Dynamic WYSIWYG Content -->
          </td>	
        </tr>

        </table> 
    </div>        			
  </div>        			
  </body>	
  </html>`,
}
